import { Box, CircularProgress, css, styled } from '@mui/material';

export const SContainer = styled(Box)(
  ({ theme }) => css`
    display: block;
    position: absolute;
    inset: 0;
    background-color: ${theme.palette.common.white};
  `,
);

export const SProgress = styled(CircularProgress)(
  ({ theme }) => css`
    color: ${theme.palette.primary[600]};
    position: absolute;
    top: calc(50% - 12px);
    left: calc(50% - 12px);
    right: 0;
    bottom: 0;
    transform: translate(-50%, -50%);
  `,
);
